import { render } from "./진단검사의학과.vue?vue&type=template&id=0bb931d3"
import script from "./진단검사의학과.vue?vue&type=script&lang=js"
export * from "./진단검사의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__